import { Empty } from "antd";
import { useTranslation } from "react-i18next";

import FullCenterBox from "@/components/Elements/FullCenterBox";

const CenteredEmpty = (props) => {
  const { t } = useTranslation();

  return (
    <FullCenterBox>
      <Empty {...props} description={t("global:noData")} />
    </FullCenterBox>
  );
};

export default CenteredEmpty;
